import {SvgIcon} from "@mui/material";

export default function FilterIcon(props) {
    return (
        <SvgIcon viewBox={`0 0 24 24`} fill="none"
                 xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_273_5641)">
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M4 13C4.55228 13 5 13.4477 5 14V21C5 21.5523 4.55228 22 4 22C3.44772 22 3 21.5523 3 21V14C3 13.4477 3.44772 13 4 13Z"
                      fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M4 2C4.55228 2 5 2.44772 5 3V10C5 10.5523 4.55228 11 4 11C3.44772 11 3 10.5523 3 10V3C3 2.44772 3.44772 2 4 2Z"
                      fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M12 11C12.5523 11 13 11.4477 13 12V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V12C11 11.4477 11.4477 11 12 11Z"
                      fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M12 2C12.5523 2 13 2.44772 13 3V8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8V3C11 2.44772 11.4477 2 12 2Z"
                      fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M20 15C20.5523 15 21 15.4477 21 16V21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21V16C19 15.4477 19.4477 15 20 15Z"
                      fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M20 2C20.5523 2 21 2.44772 21 3V12C21 12.5523 20.5523 13 20 13C19.4477 13 19 12.5523 19 12V3C19 2.44772 19.4477 2 20 2Z"
                      fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M0 14C0 13.4477 0.447715 13 1 13H7C7.55228 13 8 13.4477 8 14C8 14.5523 7.55228 15 7 15H1C0.447715 15 0 14.5523 0 14Z"
                      fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M8 8C8 7.44772 8.44772 7 9 7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H9C8.44772 9 8 8.55228 8 8Z"
                      fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M16 16C16 15.4477 16.4477 15 17 15H23C23.5523 15 24 15.4477 24 16C24 16.5523 23.5523 17 23 17H17C16.4477 17 16 16.5523 16 16Z"
                      fill="white"/>
            </g>
            <defs>
                <clipPath id="clip0_273_5641">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </SvgIcon>
    );
}